import React from 'react';

function CheckmarkIcon({ width = 14, height = 22, ...rest }) {
  return (
    <svg width={width} height={height} viewBox="0 0 14 12" {...rest}>
      <g>
        <path d="M12.2179261,0.376900239 C12.5620756,-0.0550483002 13.1912274,-0.126223454 13.623176,0.217926084 C14.0551245,0.562075621 14.1262997,1.19122742 13.7821501,1.62317596 L5.81477654,11.623176 C5.41442968,12.1256588 4.65089937,12.1256588 4.25055251,11.623176 L0.217926084,6.5617509 C-0.126223454,6.12980236 -0.0550483002,5.50065056 0.376900239,5.15650102 C0.808848778,4.81235148 1.43800058,4.88352664 1.78215012,5.31547518 L5.03266453,9.39525678 L12.2179261,0.376900239 Z" />
      </g>
    </svg>
  );
}

export default CheckmarkIcon;
